import { render, staticRenderFns } from "./bookingltd.vue?vue&type=template&id=ed2d0380&"
import script from "./bookingltd.vue?vue&type=script&lang=js&"
export * from "./bookingltd.vue?vue&type=script&lang=js&"
import style0 from "./bookingltd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports